import type RoleOwnerRepository from "@/core/administration/repositories/RoleOwnerRepository";
import type { RoleOwnersResponse } from "@/core/administration/repositories/RoleOwnerRepository";
import type { ApiRoleOwnerItem } from "@/core/administration/entities/RoleOwner";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import RoleOwnerMapper from "@/core/administration/mappers/RoleOwnerMapper";
import { getRoleOwnersUrl } from "../../api/roleOwnerBackendEndpoints/roleOwnerBackendEndpoints";

export default class RoleOwnerRepositoryBackend implements RoleOwnerRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async getRoleOwners(): Promise<
    import("@/core/shared/types/RepositoryResult").RepositoryResult<RoleOwnersResponse>
  > {
    return executeRequest(
      () =>
        this.httpClient.get<
          ApiResponse<{ items: ApiRoleOwnerItem[]; totalElements: number }>
        >({
          url: getRoleOwnersUrl(),
          withAuth: true,
        }),
      (data) => {
        const rawTotalElements = data.totalElements;
        const totalElements =
          typeof rawTotalElements === "number"
            ? rawTotalElements
            : typeof rawTotalElements === "string"
              ? parseInt(rawTotalElements, 10) || 0
              : 0;

        const items = RoleOwnerMapper.toDomainItems(data.items || []);

        return {
          items,
          totalElements,
        };
      },
    );
  }
}
